<template>
    <div class="blog-item" :key="id" v-if="blog">
        <div class="blog-item-img">
            <router-link :to="blogLink()">
                <ImgThumb :src="blog.avatar" width="380" height="380" alt="Thumb" />
            </router-link>
        </div>
        <div class="blog-item-info">
            <h4 class="blog-title">
                <router-link :to="blogLink()">{{ blog.name }}</router-link>
            </h4>

            <div class="blog-item-meta">
                <ul>
                    <li>
                        <router-link :to="blogLink()"><i class="far fa-calendar-alt"></i>
                            {{ timeString(blog.lastUpdate) }}</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
const axios = require("axios").default;
import ImgThumb from "@/components/Shared/ImgThumb.vue";
export default {
    props: ["id"],
    data() {
        return {};
    },
    components: { ImgThumb },
    computed: {
        blog() {
            return this.$store.getters.blog(this.id);
        },
    },
    mounted() { },
    methods: {
        blogLink() {
            if (this.blog) {
                return "/kobler/bai-viet/" + this.blog.alias + "/" + this.blog._id;
            } else {
                return "/";
            }
        },
        timeString(time) {
            return new Date(time).toLocaleDateString();
        },
        async getBlog(id) {
            try {
                let res = await axios.get("/api/article/" + id);
                this.blog = res.data;
            } catch {
                console;
            }
        },
    },
    watch: {
        id(val) {
            if (val.length == 24) {
                this.getBlog(val);
            }
        },
    },
};
</script>

<style lang="less">
.blog-wrapper {
    .splide__track {
        .splide__list {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            gap: 1px;
            padding: 1px;

            >.blog-item {
                width: 49%;
                outline: 1px solid #ccc;
                padding: 10px 10px 10px 10px;
                position: relative;

                .blog-item-img {
                    padding-top: 100%;
                    position: relative;

                    a {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        display: flex;
                        justify-content: center;
                        flex-direction: column;

                        img {
                            max-width: 100%;
                            max-height: 100%;
                        }

                    }

                }

                .blog-item-info {
                    padding-top: 10px;

                    a {
                        color: inherit;
                        text-decoration: none;
                    }

                    ul {
                        list-style: none;
                        margin: 0;
                        padding: 0;
                    }

                    .blog-title {}
                }
            }
        }
    }
}


@media (min-width: 500px) {
    .blog-wrapper {
        .splide__track {
            .splide__list {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                >.blog-item {
                    width: calc(50% - 2px);
                    padding: 10px 10px 10px 10px;

                    .blog-item__row {
                        width: 100%;
                    }

                    .product-block {
                        .content {
                            .description {
                                .price {
                                    font-size: 16px;
                                }

                            }

                        }
                    }
                }
            }
        }
    }
}

@media (min-width: 600px) {

    .blog-wrapper {
        .splide__track {
            .splide__list {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                >.blog-item {
                    width: calc(33.3% - 2px);
                    padding: 10px 10px 10px 10px;

                    .blog-item__row {
                        width: 100%;
                    }
                }
            }
        }
    }

}


@media (min-width: 768px) {
    .blog-wrapper {
        .splide__track {
            .splide__list {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                >.blog-item {
                    width: calc(25% - 2px);
                    padding: 10px 10px 10px 10px;

                    .blog-item__row {
                        width: 100%;
                    }
                }
            }
        }
    }
}


@media (min-width: 992px) {
    .blog-wrapper {
        .splide__track {
            .splide__list {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                >.blog-item {
                    width: calc(20% - 2px);
                    padding: 10px 10px 10px 10px;

                    .blog-item__row {
                        width: 100%;
                    }
                }
            }
        }
    }
}

@media (min-width: 1200px) {
    .blog-wrapper {
        .splide__track {
            .splide__list {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                >.blog-item {
                    width: calc(16.6% - 2px);
                    padding: 10px 10px 10px 10px;

                    .blog-item__row {
                        width: 100%;
                    }
                }
            }
        }
    }

}


@media (min-width: 1400px) {
    .blog-wrapper {
        .splide__track {
            .splide__list {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                >.blog-item {
                    width: calc(14.28% - 2px);
                    padding: 10px 10px 10px 10px;

                    .blog-item__row {
                        width: 100%;
                    }
                }
            }
        }
    }


}
</style>